"use strict";
var $ = require("../internals/export");
var floatRound = require("../internals/math-float-round");
var FLOAT16_EPSILON = 9765625e-10;
var FLOAT16_MAX_VALUE = 65504;
var FLOAT16_MIN_VALUE = 6103515625e-14;
$({ target: "Math", stat: true }, {
  f16round: function f16round(x) {
    return floatRound(x, FLOAT16_EPSILON, FLOAT16_MAX_VALUE, FLOAT16_MIN_VALUE);
  }
});
